<template>
  <Card
    :has-body-padding-small="true"
  >
    <template #body>
      <PostHeader
        :post="article"
        :use-updated-at="true"
      />
      <PostTitle
        :post="article"
        :post-url="postUrl"
      />
      <PostContent
        class="tw-mt-6"
        :post="article"
      />
    </template>
  </Card>
</template>

<script>
export default {
  name: 'NewsArticle',

  props: {
    article: {
      type: Object,
      required: true,
    },
  },

  computed: {
    postUrl() {
      return `/news/post/${this.article.slug}`;
    },
  },
};
</script>
